import { TtSetPoints } from '../services/tabletennis/ttModelService';

export interface ParsedSetScores {
  sets: TtSetPoints[];
  /** Set when the text could not be read; `sets` is then empty. */
  error?: string;
}

// One finished set, written the way a score is normally read out: "11-7".
const SET_SCORE = /^(\d{1,3})\s*[-:]\s*(\d{1,3})$/;

/**
 * Reads a comma-separated list of finished set scores, e.g. `11-7, 8-11`. Empty text means a match
 * that has not started. The scores are not checked against the rules of a legal set final: the point
 * of the what-if tool is to price states, including ones the feed reports imperfectly.
 */
export function parseSetScores(input: string): ParsedSetScores {
  const trimmed = input.trim();
  if (!trimmed) {
    return { sets: [] };
  }

  const sets: TtSetPoints[] = [];
  for (const token of trimmed.split(',')) {
    const set = token.trim();
    if (!set) {
      continue;
    }
    const match = SET_SCORE.exec(set);
    if (!match) {
      return { sets: [], error: `"${set}" is not a set score — write each finished set as 11-7` };
    }
    sets.push({ pointsA: parseInt(match[1], 10), pointsB: parseInt(match[2], 10) });
  }
  return { sets };
}

/** The set now being played: the one after every finished set. */
export function currentSetNumber(sets: TtSetPoints[]): number {
  return sets.length + 1;
}
